// components/PageHeader.jsx
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import logo from "./logo192.png";

export default function PageHeader() {
  const navigate = useNavigate();

  return (
    <div style={styles.header}>
      <button onClick={() => navigate(-1)} style={styles.backBtn} aria-label="Go back">
        <FiArrowLeft size={20} strokeWidth={2} />
      </button>
      <img src={logo} alt="Soil Sista" style={styles.logo} />
      <div style={styles.spacer} />
    </div>
  );
}

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    padding: "0.75rem 1.25rem",
    background: "white",
    borderBottom: "1px solid rgba(0,0,0,0.07)",
    position: "sticky",
    top: 0,
    zIndex: 50,
  },
  backBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "6px",
    borderRadius: "8px",
    color: "var(--soil-green)",
    display: "flex",
    alignItems: "center",
  },
  logo: {
    height: "36px",
    width: "36px",
    objectFit: "contain",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  },
  spacer: {
    width: "32px",
  },
};